import { Alert, Button } from '@src/controls';
import { useFormatMessage } from '@src/i18n';
import { setForgeAutoRedirect } from '@src/services/cookies-service';
import { ForgePath, getForgeOptInUrl } from '@src/services/forge-service';
import { captureEvent } from '@src/services/posthog-service';
import { useForgeAutoRedirect, useMasterSiteId } from '@src/utils/hooks';
import React from 'react';
import { keyframes, style } from 'typestyle';

const pulseKeyframes = keyframes({
  '0%': { boxShadow: '0 0 0 0 rgba(123, 97, 255, 0.55)' },
  '70%': { boxShadow: '0 0 0 14px rgba(123, 97, 255, 0)' },
  '100%': { boxShadow: '0 0 0 0 rgba(123, 97, 255, 0)' },
});

const pulseClass = style({
  animationName: pulseKeyframes,
  animationDuration: '1.6s',
  animationIterationCount: 5,
  animationTimingFunction: 'ease-out',
  borderRadius: '2px',
});

function redirectToForge(siteId: string, path?: ForgePath) {
  captureEvent('new_app_experience_opt_in');
  setForgeAutoRedirect();
  window.location.href = getForgeOptInUrl(siteId, path);
}

type Props = {
  /** Where to land in the new app. Defaults to the checkout routes page. */
  path?: ForgePath;
};

export function NewForgeExperienceAlert({ path }: Props) {
  const formatMessage = useFormatMessage();
  const siteId = useMasterSiteId();

  useForgeAutoRedirect(!!siteId, path);

  if (!siteId) {
    return null;
  }

  return (
    <Alert
      className={pulseClass}
      description={formatMessage('NEW_EXPERIENCE_ALERT_DESC')}
      message={formatMessage('NEW_EXPERIENCE_ALERT_TITLE')}
      action={
        <Button type="default" htmlType="button" onClick={() => redirectToForge(siteId, path)}>
          {formatMessage('NEW_EXPERIENCE_ALERT_CTA')}
        </Button>
      }
      style={{ marginBottom: '24px' }}
      type="info"
    />
  );
}
